import { ResultOf } from 'gql.tada';
import { gql } from '@/modes/company/gql';

export const GET_TESTER_IDS = gql(`
  query GetTesterIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    vendors(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
    }
  }
`);

export const GET_TESTERS = gql(`
  query GetTesters(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    vendors(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
      id
      accountNumber
      status
      profile(required: true) {
        id
        type
        name
        phones {
          id
          value
        }
        emails {
          id
          value
        }
      }
    }
  }
`);

export type GetTestersResult = ResultOf<typeof GET_TESTERS>;
export type TesterItem = GetTestersResult['vendors'][number];
